'use client';
import { useEffect } from 'react';
import { useAppSelector } from '../v2/hooks/useAppSelector/UseAppSelector';
import { useIsSidebarOpenSelector } from '../v2/store/selectors';
import dynamic from 'next/dynamic';
// import * as Sentry from '@sentry/nextjs';
const LogoIconDynamic = dynamic(() => import('../v2/assets/icons/LogoIcon'), {
  ssr: false,
});
const ButtonDynamic = dynamic(() => import('../v2/components/Button/Button'), {
  ssr: false,
});
export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const isMenuOpen = useAppSelector(useIsSidebarOpenSelector);

  useEffect(() => {
    // (async () => {
    //   try {
    //     await Sentry.captureException(error, {
    //       tags: {
    //         environment: process.env.NODE_ENV || 'development',
    //       },
    //     });
    //   } catch (sentryError) {
    //     // Fallback to console in case Sentry fails
    //     console.error('Failed to report error to Sentry:', error);
    //   }
    // })();
  }, [error]);

  return (
    <div
      className="vCenterFirst"
      style={{
        paddingLeft: isMenuOpen ? `15rem` : `4.25rem`,
        textAlign: 'center',
      }}
    >
      <div
        className="vCenter"
        style={{ width: `calc(100% - ${isMenuOpen ? `15rem` : `4.25rem`})` }}
      >
        <LogoIconDynamic width={100} height={30} />
        <h2>ERROR</h2>
        <h4>Something Went Wrong.</h4>
        <h4>Let’s Go Home and Try Again!</h4>
        <ButtonDynamic
          label={`Return to Homepage`}
          type={'primary-v2'}
          onClick={() => (window.location.href = '/')}
        />
      </div>
    </div>
  );
}
